import { IExperimentList } from "services/types";

export interface IExperimentsState {
  experiments: IExperimentList;
  loading: boolean;
  error: Error | null;
}

const defaultState = {
  experiments: {
    hls: false,
  },
  loading: false,
  error: null,
};

export const getDefaultExperimentsState = () => defaultState;
